import { useEffect, useRef, useState } from "react";
import {
  Autocomplete,
  CurrencyInput,
  Grid,
  TextField,
  TextFielDecimalNumbers,
} from "../../../../components";
import {
  responseErros,
  timeoutBuscaAutocomplete,
  unformatPrice,
} from "../../../../utils";
import { AnpService } from "../../../../services";
import { value } from "../../../../helpers";

const FormCombustivelDialog = ({
  produto,
  setProduto,
  produtoEntity,
  inputErros,
  loadingAutoComplete,
  setLoadingAutoComplete,
  handleChangeAutocomplete,
  listaUnidadesComerciais,
  estados
}) => {
  const inputRef = useRef();
  const [anps, setAnps] = useState([]);
  const anpService = new AnpService();

  const indicadores = [
    {
      codigo: "0",
      descricao: "Nacional",
    },
    {
      codigo: "1",
      descricao: "Importado",
    },
  ];

  useEffect(() => {
    if (!produto?.unidadeTributavelId && produto?.unidadeComercialVendaId) {
      produtoEntity.setHandleChangeInput(
        "unidadeTributavelId",
        produto.unidadeComercialVendaId
      );
      setProduto({ ...produtoEntity });
    }
    
    initAnpCodigo();
  }, []);

  const initAnpCodigo = async () => {
    if (produto?.anpCodigo) {
      await buscarAnps({ codigo: produto.anpCodigo });
    }
  };

  const buscarAnps = async (filtro) => {
    const filtros = {
      ...filtro,
      limite: 20,
    };
    const result = await anpService.getAllAvancado(filtros);
    if (!result.isAxiosError) {
      setLoadingAutoComplete(false);
      setAnps(result.data.rows);
      if (result.data.rows?.length) return result.data.rows;
    } else {
      setLoadingAutoComplete(false);
      responseErros(result);
    }
  };

  const handleFloatChange = (e) => {
    const unformatValue = unformatPrice(e.target.value);
    produtoEntity.setHandleChangeInput(e.target.name, unformatValue);
    setProduto({ ...produtoEntity });
  };

  const handleInputChange = (e) => {
    produtoEntity.setHandleChangeInput(e.target.name, e.target.value);
    setProduto({ ...produtoEntity });
  };

  const nextFocusInput = (event) => {
    let inputCount = 2;
    if (event.keyCode === 13 && event.target.nodeName === "INPUT") {
      const { form } = event.target;
      if (!form) return;
      const index = Array.from(form.elements).indexOf(event.target);
      let element = form.elements[index + inputCount];
      if (element?.disabled) {
        element = form.elements[index + inputCount + 2];
      }
      if (element) {
        element.focus();
      }
      event.preventDefault();
    }
  };

  const onInputChangeAnp = (event) => {
    if (event.key === "Enter" && inputRef.current === document.activeElement) {
      const eventValue = event.target?.value;
      if (eventValue?.length >= 2) {
        const filtros = {
          codigo: eventValue,
        };
        setLoadingAutoComplete(true);
        timeoutBuscaAutocomplete(buscarAnps(filtros));
      }
    }
  };

  return (
    <>
      <Grid container spacing={2} alignItems="center">
        <Grid item xs={5}>
          <Autocomplete
            required
            id="anpCodigo"
            name="anpCodigo"
            options={anps}
            autoHighlight
            loading={loadingAutoComplete}
            loadingText="Carregando"
            noOptionsText="Digite e pressione Enter"
            filterSelectedOptions
            getOptionLabel={(option) =>option ? option?.codigo : ""}
            renderInput={(params) => (
              <TextField
                {...params}
                variant="outlined"
                label="Código ANP"
                onKeyDown={(e) => onInputChangeAnp(e)}
                inputRef={inputRef}
                InputProps={{
                  ...params.InputProps,
                }}
                error={inputErros.get("anpCodigo")}
                required
              />
            )}
            onChange={(_, value) => {
              produtoEntity.resetPercentuaisGLP();
              produtoEntity.setHandleChangeInput("anpCodigo", value?.codigo);
              produtoEntity.setHandleChangeInput("anpDescricao", value?.descricao);
              setProduto({ ...produtoEntity });
            }}
            value={anps.find((item) => item?.codigo === produto?.anpCodigo)}
          />
        </Grid>
        <Grid item xs={7}>
          <TextField
            id="anpDescricao"
            name="anpDescricao"
            label="Descrição do Produto (ANP)"
            variant="filled"
            InputLabelProps={{ shrink: true }}
            value={produto?.anpDescricao}
            onChange={handleInputChange}
            error={inputErros.get("anpDescricao")}
            fullWidth
            disabled
          />
        </Grid>
        <Grid item xs={4}>
          <Autocomplete
            id="unidadeTributavelId"
            name="unidadeTributavelId"
            options={listaUnidadesComerciais}
            noOptionsText="Sem opções"
            getOptionLabel={(option) => (option ? option.descricao : "")}
            autoHighlight
            renderInput={(params) => (
              <TextField
                {...params}
                label="Unidade Tributável"
                variant="outlined"
                error={inputErros.get("unidadeTributavelId")}
                margin="normal"
              />
            )}
            onChange={(_, value) => {
              handleChangeAutocomplete("unidadeTributavelId", value);
            }}
            value={value.autoComplete(
              listaUnidadesComerciais,
              produto?.unidadeTributavelId
            )}
          />
        </Grid>
        <Grid item xs={4}>
          <TextField
            id="qtdTributavel"
            name="qtdTributavel"
            label="Quantidade Tributável"
            variant="outlined"
            type="number"
            disableNumberArrows
            InputLabelProps={{ shrink: true }}
            value={produto?.qtdTributavel}
            onChange={handleInputChange}
            error={inputErros.get("qtdTributavel")}
            fullWidth
            margin="normal"
          />
        </Grid>
        <Grid item xs={4}>
          <TextFielDecimalNumbers
            required={produtoEntity?.anpCodigo === "210203001"}
            id="glp"
            name="glp"
            label="GLP"
            variant="outlined"
            disabled={produtoEntity?.anpCodigo !== "210203001"}
            onKeyDown={(e) => nextFocusInput(e)}
            value={produto?.glp}
            onBlur={handleFloatChange}
            fullWidth
            error={inputErros.get("glp")}
            margin="normal"
            InputLabelProps={{ shrink: true }}
          />
        </Grid>
        <Grid item xs={4}>
          <TextFielDecimalNumbers
            required={produtoEntity?.anpCodigo === "210203001"}
            id="gasNaturalNacional"
            name="gasNaturalNacional"
            label="Gás Natural Nacional"
            variant="outlined"
            disabled={produtoEntity?.anpCodigo !== "210203001"}
            onKeyDown={(e) => nextFocusInput(e)}
            value={produto?.gasNaturalNacional}
            onBlur={handleFloatChange}
            fullWidth
            error={inputErros.get("gasNaturalNacional")}
            margin="none"
            InputLabelProps={{ shrink: true }}
          />
        </Grid>
        <Grid item xs={4}>
          <TextFielDecimalNumbers
            required={produtoEntity?.anpCodigo === "210203001"}
            id="gasNaturalImp"
            name="gasNaturalImp"
            label="Gás Natural Importado"
            variant="outlined"
            disabled={produtoEntity?.anpCodigo !== "210203001"}
            onKeyDown={(e) => nextFocusInput(e)}
            value={produto?.gasNaturalImp}
            onBlur={handleFloatChange}
            fullWidth
            error={inputErros.get("gasNaturalImp")}
            margin="none"
            InputLabelProps={{ shrink: true }}
          />
        </Grid>
        <Grid item xs={4}>
          <CurrencyInput
            required
            id="valorPartida"
            name="valorPartida"
            label="Valor de partida"
            onKeyDown={(e) => nextFocusInput(e)}
            value={produto?.valorPartida}
            onBlur={handleFloatChange}
            error={inputErros.get("valorPartida")}
            margin="none"
          />
        </Grid>
        <Grid item xs={4}>
          <TextField
            required
            id="codif"
            name="codif"
            label="CODIF"
            variant="outlined"
            type="number"
            disableNumberArrows
            InputLabelProps={{ shrink: true }}
            value={produto?.codif}
            onChange={handleInputChange}
            InputProps={{ inputProps: { min: 0 } }}
            error={inputErros.get("codif")}
            fullWidth
          />
        </Grid>
        <Grid item xs={4}>
          <TextField
            required
            id="qtdCombTempAmbiente"
            name="qtdCombTempAmbiente"
            label="Qtd. Combustível em Temp Ambiente"
            variant="outlined"
            type="number"
            disableNumberArrows
            InputLabelProps={{ shrink: true }}
            value={produto?.qtdCombTempAmbiente}
            onChange={handleInputChange}
            error={inputErros.get("qtdCombTempAmbiente")}
            fullWidth
          />
        </Grid>
        <Grid item xs={4}>
          <CurrencyInput
            required
            id="bcCide"
            name="bcCide"
            label="BC da CIDE"
            onKeyDown={(e) => nextFocusInput(e)}
            value={produto?.bcCide}
            onBlur={handleFloatChange}
            error={inputErros.get("bcCide")}
          />
        </Grid>
        <Grid item xs={4}>
          <CurrencyInput
            required
            id="aliquotaCide"
            name="aliquotaCide"
            label="Alíquota da CIDE"
            onKeyDown={(e) => nextFocusInput(e)}
            value={produto?.aliquotaCide}
            onBlur={handleFloatChange}
            error={inputErros.get("aliquotaCide")}
            margin="none"
          />
        </Grid>
        <Grid item xs={4}>
          <CurrencyInput
            required
            id="valorCide"
            name="valorCide"
            label="Valor da CIDE"
            onKeyDown={(e) => nextFocusInput(e)}
            value={produto?.valorCide}
            onBlur={handleFloatChange}
            error={inputErros.get("valorCide")}
            margin="none"
          />
        </Grid>
        <Grid item xs={4}>
          <Autocomplete
            required
            id="indicadorImportacao"
            name="indicadorImportacao"
            options={indicadores}
            noOptionsText="Sem opções"
            getOptionLabel={(option) =>
              option ? `${option?.codigo} - ${option?.descricao}` : ""
            }
            autoHighlight
            renderInput={(params) => (
              <TextField
                {...params}
                label="Indicador de Importação"
                variant="outlined"
                required
                error={inputErros.get("indicadorImportacao")}
              />
            )}
            onChange={(_, value) => {
              produtoEntity.setHandleChangeInput(
                "indicadorImportacao",
                value?.codigo
              );
              setProduto({ ...produtoEntity });
            }}
            value={indicadores.find(
              (item) => item.codigo === produto?.indicadorImportacao
            )}
          />
        </Grid>
        <Grid item xs={4}>
          <Autocomplete
            required
            id="ufOrigem"
            name="ufOrigem"
            options={estados}
            noOptionsText="Sem opções"
            getOptionLabel={(option) => (option ? option.sigla : "")}
            autoHighlight
            renderInput={(params) => (
              <TextField
                {...params}
                label="UF de Origem"
                variant="outlined"
                required
                error={inputErros.get("ufOrigem")}
                margin="normal"
              />
            )}
            onChange={(_, value) => {
              produtoEntity.setHandleChangeInput("ufOrigem", value?.codigo);
              produtoEntity.setHandleChangeInput("percentualUf", 100.00);
              setProduto({ ...produtoEntity });
            }}
            value={estados.find((item) => item.codigo === produto?.ufOrigem)}
          />
        </Grid>
        <Grid item xs={4}>
          <TextFielDecimalNumbers
            required
            id="percentualUf"
            name="percentualUf"
            label="Perc. Originário para UF"
            variant="filled"
            disabled
            onKeyDown={(e) => nextFocusInput(e)}
            value={produto?.percentualUf}
            onBlur={handleFloatChange}
            fullWidth
            error={inputErros.get("percentualUf")}
            InputLabelProps={{ shrink: true }}
          />
        </Grid>
      </Grid>
    </>
  );
};

export default FormCombustivelDialog;
